/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TaskTypeEnum {
    DELIVERABLE = 'DELIVERABLE',
    DATA_EXTRACTION = 'DATA_EXTRACTION',
    BANK_CONNECTION = 'BANK_CONNECTION',
    CLUSTER_TASK = 'CLUSTER_TASK',
}
